import React from 'react';
import _get from 'lodash/get';
import StickyTimer from '../../../components/StickyTimer/StickyTimerContent';

export default (props) => { // eslint-disable-line
    const { featureFlags } = props;
    const stickyTimerDetails = {
        finalHourThreshold: '5:00',
        finalDayThreshold: 24,
        finalHoursText: props.eventType === 'coupon' ? 'Final Hours Of' : '', // Need to clean up this code. value should render from preference instead of hardcoded value
    };
    return (
        <StickyTimer
            stickyTimerData={{ content: props }}
            isPreview={_get(props, 'isPreview', false)}
            enableEventBasedStickyTimer={_get(featureFlags, 'enableEventBasedStickyTimer', true)}
            disableSitewideSeoUrl={_get(featureFlags, 'disableSitewideSeoUrl', true)} // this value is passed only to iris intool, not for yoda
            enableThreshold={_get(featureFlags, 'enableThreshold', true)}
            stickyTimerDetails={stickyTimerDetails}
            enableIristzOffset={_get(featureFlags, 'enableIristzOffset', true)}
        />
    );
};
